import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/help/:helpId',
    name: 'Help',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Help.vue')
  },
  {
    path: '/airbox/:eventId',
    name: 'Airbox',
    component: () => import(/* webpackChunkName: "about" */ '../views/Airbox.vue')
  },
  {
    path: '/airboxmap/:eventId',
    name: 'AirboxMap',
    component: () => import(/* webpackChunkName: "about" */ '../views/AirboxMap.vue')
  },
  {
    path: '/airbox/pilots',
    name: 'Pilots',
    component: () => import(/* webpackChunkName: "about" */ '../views/airbox/Pilots.vue')
  },
  // {
  //   path: '/events',
  //   name: 'Events',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/Events.vue')
  // },
  {
    path: '/boxlist',
    name: 'BoxList',
    component: () => import(/* webpackChunkName: "about" */ '../views/BoxList.vue')
  },
  {
    path: '/eventlist',
    name: 'Event List',
    component: () => import(/* webpackChunkName: "about" */ '../views/EventList.vue')
  },
  // {
  //   path: '/eventopenclose',
  //   name: 'EventOpenClose',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/Event/EventOpenClose.vue')
  // },
  {
    path: '/boxopenclose',
    name: 'BoxOpenClose',
    component: () => import(/* webpackChunkName: "about" */ '../views/Event/BoxOpenClose.vue')
  },
  {
    path: '/eventadmin',
    name: 'EventAdmin',
    component: () => import(/* webpackChunkName: "about" */ '../views/Event/EventAdmin.vue')
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/AdminFront.vue')
  },
  {
    path: '/boxadmin',
    name: 'BoxAdmin',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/BoxAdmin.vue')
  },
  {
    path: '/happadmin',
    name: 'HappAdmin',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/HappAdmin.vue')
  },
  {
    path: '/event/:id',
    name: 'EventDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/Event/Happ.vue')
  },
  {
    path: '/newuser',
    name: 'Newuser',
    component: () => import(/* webpackChunkName: "about" */ '../views/NewUser.vue')
  },
  {
    path: '/airbox/pilotstatus/:id',
    name: 'PilotStatus',
    component: () => import(/* webpackChunkName: "about" */ '../views/airbox/PilotStatus.vue')
  },
  {
    path: '/airbox/addmyposition/:id/:eventid',
    name: 'AddMyPosition',
    component: () => import(/* webpackChunkName: "about" */ '../views/airbox/AddMyPosition.vue')
  },
  {
    path: '/airbox/addpilotposition/:id/:eventid',
    name: 'AddPilotPosition',
    component: () => import(/* webpackChunkName: "about" */ '../views/airbox/AddPilotPosition.vue')
  },
  {
    path: '/checkin',
    name: 'CheckIn',
    component: () => import(/* webpackChunkName: "about" */ '../views/CheckIn.vue')
  },

  {
    path: '/airbox/addmsg/:id',
    name: 'AddMsg',
    component: () => import(/* webpackChunkName: "about" */ '../views/airbox/AddMsg.vue')
  },
  {
    path: '/airspace',
    name: 'AirSpace',
    component: () => import(/* webpackChunkName: "about" */ '../views/AirSpace.vue')
  },
  {
    path: '/profile/:profileKey',
    name: 'Profile',
    component: () => import(/* webpackChunkName: "about" */ '../views/Profile.vue')
  },
  {
    path: '/sendac',
    name: 'SendAC',
    component: () => import(/* webpackChunkName: "about" */ '../views/SendAC.vue')
  },
  {
    path: '/getprofile',
    name: 'GetProfile',
    component: () => import(/* webpackChunkName: "about" */ '../views/GetProfile.vue')
  },
  {
    path: '/adminnotificationstatus',
    name: 'AdminNotificationStatus',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/AdminNotificationStatus.vue')
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Test.vue')
  },
  {
    path: '/test2',
    name: 'Test2',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Test2.vue')
  },
  {
    path: '/devtest',
    name: 'devtest',
    component: () => import(/* webpackChunkName: "about" */ '../views/airbox/AddPilotPosition.vue')
  },
  {
    path: '/login',
    name: 'LogIn',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/LogIn.vue')
  },
  {
    path: '/rules',
    name: 'Rules',
    component: () => import(/* webpackChunkName: "about" */ '../views/Rules.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
